// extracted by mini-css-extract-plugin
export default {"item":"ContractView_item__qfD+I","tools":"ContractView_tools__SuB7R"};